import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Presentation composable that provides access to presentation-related getters and actions
 */
export function usePresentation() {
  const store = useStore();

  // Presentation getters
  const disclaimers = computed(() => store.getters['presentation/GET_DISCLAIMERS']);
  const disclaimerContent = computed(() => store.getters['presentation/GET_DISCLAIMER_CONTENT']);
  const presentation = computed(() => store.getters['presentation/GET_PRESENTATION_DETAILS']);
  const accessCodes = computed(() => store.getters['presentation/GET_ACCESS_CODES']);

  // Presentation actions
  const fetchDisclaimers = () => store.dispatch('presentation/fetchDisclaimers');
  const fetchDisclaimerContent = () => store.dispatch('presentation/fetchDisclaimerContent');
  const removeFirstDisclaimerFromStore = () => store.dispatch('presentation/removeFirstDisclaimerFromStore');
  const fetchAccessCodes = (params) => store.dispatch('presentation/fetchAccessCodes', params);

  return {
    // Getters
    disclaimers,
    disclaimerContent,
    presentation,
    accessCodes,
    
    // Actions
    fetchDisclaimers,
    fetchDisclaimerContent,
    removeFirstDisclaimerFromStore,
    fetchAccessCodes,
  };
}
